require('/opt/odin/app/frontend/components/new_button_follow/index.module.scss');module.exports = "../../app/cells/components/new_button_follow/show.erb";